import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: "root"
  })

  export class AdesaoService {


    constructor(private http: HttpClient, private util: UtilService) {}

    //lista sexo.
    public ListarGenero(): Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarSexo`);
    }

    //lista Estado civíl
    public ListarEstadoCivil(): Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarEstadoCivil`)
    }

    //lista Nacionalidade
    public ListarNacionalidades():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarNacionalidades`);
    }

    //lista Estado
    public ListarEstado():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarUFs`);
    }

    //lista Cidades
    public ListarCidade():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarCidades`);
    }

    //lista Parentesco
    public ListarParentesco():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarParentesco`);
    }

    //lista Instituidores
    public ListarInstituidores():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarInstituidores`);
    }

    //lista os tipos de vinculo
    public ListarTiposDeVinculo():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/ListarTiposDeVinculo`);
    }

    //lista Parentesco Beneficiario
    public ListarParentescoBenef():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarParentescoBenf`);
    }

    //lista País
    public ListarPais():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarPais`);
    }

    public ListarCidadePorUf(codUF):Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarCidadesPorUF`, {params: {codUF: codUF}})
    }

    public ListarTipoRep(){
        return this.http
                   .get(`${environment.apiURL}/CadastroGenerico/ListarTipoRepresentante`)
    }

    public salvarNif(dados):Observable<any>{
        return this.http
                   .post(`${environment.apiURL}/Logado/Adesao/SalvarNIF`,this.util.flattenObject(dados));
    }

    public listarNif():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/ListarNif`);
    }

    public removerNif(dcrNif):Observable<any>{
        return this.http
                   .delete(`${environment.apiURL}/Logado/Adesao/RemoverNIf`,{params:{dcrNif:dcrNif}});
    }

    //salva adesão
    public salvar(dados,tab:string="",idc_adesao_inicial?: number){

        const url = `${environment.apiURL}/Logado/Adesao/Salvar?idc_adesao_inicial=${idc_adesao_inicial}`;

        return this.http.post(url, this.util.flattenObject(dados));
    }

    public salvarRepresentante(dados){
        return this.http
                   .post(`${environment.apiURL}/Logado/Adesao/SalvarRepresentante`,dados)
    }

    public salvaAporte(valor,data,idcPrimeiroAporte){
        return this.http
                   .get(`${environment.apiURL}/Logado/Aporte/GerarBoleto`,{params:{valor:valor,data:data, idcPrimeiroAporte: idcPrimeiroAporte}})
    }

    public salvaAportePix(valor,data,idcPrimeiroAporte){
        return this.http
                   .get(`${environment.apiURL}/Logado/Aporte/GerarPix`,{params:{valor:valor,data:data, idcPrimeiroAporte: idcPrimeiroAporte}})
    }

    public BuscarCobranca(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Aporte/DadosCobranca`);
    }

    public carregar(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/Carregar`);
    }


    public carregaTabelaIRProgressivo(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/CarregaTabelaIRProgressivo`)
    }


    public carregaTabelaIRRegressivo(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/CarregaTabIRRegressivo`)
    }

    public buscaPrimeiroRegimeTributacao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/BuscaPrimeiroRegimeTributacao`)
    }

    public buscarValorMinimoContribuicao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/BuscarValorMinimoContribuicao`)
    }

    public carregaDadosConclusao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/CarregaDadosConfirmacao`)
    }

    public finalizarAdesao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/FinalizarAdesao`)
    }

    public verificaSeTemFusan(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/VerificaSeTemFusan`)
    }

    public verificarCarteiraASPP(numero: string){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/VerificarCarteiraASPP`, {params:{numero: numero}})
    }

    public verificaAdesaoFinalizada(cpf){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/VerificaAdesaoFinalizada`,{params:{cpf:cpf}})
    }

    public downloadCertificado(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Adesao/DownLoadCertificado`, {responseType: "blob"});
    }

    public dadosBoleto(codCobranca: number){
        return this.http
                   .get(`${environment.apiURL}/Logado/Aporte/DadosBoleto?codCobranca=${codCobranca}`)
  }

  public gerarBoleto(codCobranca: number){

    return this.http
               .get(`${environment.apiURL}/Logado/Aporte/GerarBoletoBaixar?codCobranca=${codCobranca}`, {responseType: "blob"})
  }
  public consultarDadosPix(codCobranca: number){

    return this.http
               .get(`${environment.apiURL}/Logado/Aporte/DadosPix?codCobranca=${codCobranca}`)
  }


  public CobrancaPaga(){

    return this.http
               .get(`${environment.apiURL}/Logado/Adesao/CobrancaPaga`)
  }

  public BuscarDadosCobranca(){

    return this.http
               .get(`${environment.apiURL}/Logado/Adesao/BuscaDadosCobranca`)
  }

}
